import { Wind } from "lucide-react";
import { COMPANY } from "@/i18n";
import { FooterContact, FooterArea } from "@/components/footer/FooterColumns";

export default function Footer({ t }) {
  return (
    <footer className="bg-[var(--primary)] text-white py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-xl bg-white/15 flex items-center justify-center">
              <Wind className="w-5 h-5 text-white" />
            </div>
            <span className="font-heading text-xl">
              A<span className="text-[var(--accent)]">·</span>team
            </span>
          </div>
          <p className="text-white/70 max-w-xs">{t.footer.tag}</p>
        </div>
        <FooterContact t={t} />
        <FooterArea t={t} />
      </div>
      <div className="max-w-7xl mx-auto px-6 sm:px-10 mt-10 pt-6 border-t border-white/15 flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between text-sm text-white/60">
        <span>
          © {new Date().getFullYear()} {COMPANY.name}. {t.footer.rights}
        </span>
        <a href="/teszt" className="link-underline text-white/60 py-1 inline-block" data-testid="footer-perf-test-link">
          Teljesítmény teszt lap
        </a>
        <a href="/aszf" className="link-underline text-white/60 py-1 inline-block" data-testid="footer-aszf-link">
          ÁSZF
        </a>
        <a href="/adatvedelem" className="link-underline text-white/60 py-1 inline-block" data-testid="footer-gdpr-link">
          Adatvédelem
        </a>
        <span>{t.footer.built}</span>
      </div>
    </footer>
  );
}
